import { render, staticRenderFns } from "./UserMaintenance.vue?vue&type=template&id=2c6a3716"
import script from "./UserMaintenance.js?vue&type=script&lang=js&external"
export * from "./UserMaintenance.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports